"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Toggle = exports.ToggleDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
exports.ToggleDefaultProps = {
  isOn: false,
  isHalfOn: false,
  onClick: function () {},
  isOnColor: 'primary',
  isOffColor: 'line'
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    cursor: pointer;\n    display: flex;\n    font-size: ", ";\n    align-items: center;\n  "], ["\n    cursor: pointer;\n    display: flex;\n    font-size: ", ";\n    align-items: center;\n  "])), theme_1.theme.FONT_SIZE(12)),
  desktop: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size: ", ";\n  "], ["\n    font-size: ", ";\n  "])), theme_1.theme.FONT_SIZE(13))
});
var TrackStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    height: 16px;\n    cursor: pointer;\n    width: 32px;\n    border-radius: 14px;\n    position: relative;\n    display: flex;\n    padding: 3px;\n    transition: all 0.3s;\n    ", "\n\n    ", "\n  "], ["\n    height: 16px;\n    cursor: pointer;\n    width: 32px;\n    border-radius: 14px;\n    position: relative;\n    display: flex;\n    padding: 3px;\n    transition: all 0.3s;\n    ", "\n\n    ", "\n  "])), function (props) {
    return (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      background-color: ", ";\n\n      &:hover {\n        filter: brightness(110%);\n      }\n    "], ["\n      background-color: ", ";\n\n      &:hover {\n        filter: brightness(110%);\n      }\n    "])), theme_1.theme.COLOR(props.isOn ? props.isOnColor : props.isOffColor));
  }, function (props) {
    return props.isOn && (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    "], ["\n    "])));
  })
});
var SwitchStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    box-sizing: content-box;\n    width: 16px;\n    height: 16px;\n    position: absolute;\n    border-radius: 14px;\n    left: 3px;\n    font-size: 0;\n    background: #FFF;\n    transition: all 0.3s;\n\n    ", "\n  "], ["\n    box-sizing: content-box;\n    width: 16px;\n    height: 16px;\n    position: absolute;\n    border-radius: 14px;\n    left: 3px;\n    font-size: 0;\n    background: #FFF;\n    transition: all 0.3s;\n\n    ", "\n  "])), function (props) {
    return props.isOn && (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      left: 19px;\n    "], ["\n      left: 19px;\n    "])));
  })
});
var LabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    font-size: 1.0em;\n    font-weight: 500;\n    text-transform: uppercase;\n    color: ", ";\n\n    ", "\n  "], ["\n    font-size: 1.0em;\n    font-weight: 500;\n    text-transform: uppercase;\n    color: ", ";\n\n    ", "\n  "])), theme_1.theme.COLOR('primary'), function (props) {
    return !props.isActive && (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), theme_1.theme.COLOR('text-subtle'));
  })
});
var OffLabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    ", ";\n    margin-right: ", ";\n  "], ["\n    ", ";\n    margin-right: ", ";\n  "])), LabelStyles, theme_1.theme.UNIT(2))
});
var OnLabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    ", ";\n    margin-left: ", ";\n  "], ["\n    ", ";\n    margin-left: ", ";\n  "])), LabelStyles, theme_1.theme.UNIT(2))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Label: styled_components_1.default.span(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), OffLabelStyles),
  Switch: styled_components_1.default.span(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), SwitchStyles),
  Track: styled_components_1.default.div(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), TrackStyles),
  OffLabel: styled_components_1.default.span(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), OffLabelStyles),
  OnLabel: styled_components_1.default.span(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), OnLabelStyles)
};
var Toggle = function (props) {
  var className = props.className,
    isOn = props.isOn,
    onClick = props.onClick,
    offLabel = props.offLabel,
    label = props.label,
    onLabel = props.onLabel,
    isOffColor = props.isOffColor,
    isOnColor = props.isOnColor;
  return react_1.default.createElement(My.Container, {
    onClick: onClick,
    className: className
  }, label && react_1.default.createElement(My.Label, null, label), offLabel && react_1.default.createElement(My.OffLabel, {
    isActive: !isOn
  }, offLabel), react_1.default.createElement(My.Track, {
    isOn: isOn,
    isOffColor: isOffColor,
    isOnColor: isOnColor
  }, react_1.default.createElement(My.Switch, {
    isOn: isOn
  })), onLabel && react_1.default.createElement(My.OnLabel, {
    isActive: isOn
  }, onLabel));
};
exports.Toggle = Toggle;
exports.Toggle.defaultProps = exports.ToggleDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17;